"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_array_1 = require("./is-array");
/**
 * Return the given item in an array, or the given array.
 *
 * @Param {Array | any} arrayOrItem - An array or array item.
 *
 * @Example
 *
 *   wrap([1, 2, 3])
 *   //=> [1, 2, 3]
 *
 *   wrap(1)
 *   //=> [1]
 */
function wrap(arrayOrItem) {
    if (is_array_1.isArray(arrayOrItem)) {
        return arrayOrItem;
    }
    return [arrayOrItem];
}
exports.wrap = wrap;
//# sourceMappingURL=wrap.js.map